import BlRatingSummaryMv from './BlRatingSummaryMv.vue'

BlRatingSummaryMv.install = function(Vue) {
  Vue.component(BlRatingSummaryMv.name, BlRatingSummaryMv)
}

export default BlRatingSummaryMv
